import { GiftListItem } from '@/app/_components/DonationTemp/GiftListItem';

interface GiftCardSkeletonListProps {
  count: number;
}

/**
 * 답례품 검색 결과 스켈레톤. `GiftListItem`의 isLoading 모드를 재사용한다.
 */
export function GiftCardSkeletonList({ count }: GiftCardSkeletonListProps) {
  return (
    <ul
      aria-busy="true"
      className="grid grid-cols-3 gap-x-16 gap-y-32 pb-40 mobile:grid-cols-2 mobile:gap-x-12 mobile:gap-y-24 mobile-tablet:px-20"
    >
      {Array.from({ length: count }, (_, index) => (
        <li key={index}>
          <GiftListItem isLoading />
        </li>
      ))}
    </ul>
  );
}
